export enum TipoMeta {
    CurtoPrazo = 'CP',
    MedioPrazo = 'MP',
    LongoPrazo = 'LP',
    Prazo = 'PR'
}

export default TipoMeta;
